import Inputmask from "inputmask";

export default class InputMask {
    /**
     * Initializes telephone input masks in the given DOM scope.
     *
     * @param {Document|Element|DocumentFragment} scope
     * @returns {void}
     */
    static masksInit(scope = document) {
        if (!scope?.querySelectorAll) return;

        const inputs = [...scope.querySelectorAll('input[type="tel"]')];
        if (scope.nodeType === 1 && scope.matches('input[type="tel"]')) {
            inputs.unshift(scope);
        }

        inputs.forEach((input) => {
            if (input.inputmask) return;

            new Inputmask("+380 (99) 999-99-99").mask(input);
        });
    }

    /**
     * Removes telephone input masks within the given DOM scope.
     *
     * @param {Document|Element|DocumentFragment} scope
     * @returns {void}
     */
    static destroyWithin(scope) {
        if (!scope?.querySelectorAll) return;

        const inputs = [...scope.querySelectorAll('input[type="tel"]')];
        if (scope.nodeType === 1 && scope.matches('input[type="tel"]')) {
            inputs.unshift(scope);
        }

        inputs.forEach((input) => {
            input.inputmask?.remove();
        });
    }
}
